import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  width?: string;
}
export function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  width = 'max-w-lg'
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-711" data-mp="1c84ikesutepg">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-navy-900/50 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onClose} data-id="element-712" data-mp="1h7z92h8pw29z">
          <motion.div role="dialog" aria-modal="true" aria-label={title} initial={{
        y: 12,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 12,
        opacity: 0
      }} transition={{
        duration: 0.18
      }} onClick={e => e.stopPropagation()} className={`max-h-[90vh] w-full overflow-hidden rounded-lg bg-white shadow-xl ${width} flex flex-col`} data-id="element-713" data-mp="24vqjtgem0795">
            <header className="flex items-center justify-between border-b border-border px-5 py-3.5" data-id="element-714" data-mp="3g85yobl8ljbw">
              <h2 className="font-heading text-base font-semibold text-navy-900" data-id="element-715" data-mp="3tz1ds5mbwwnx">{title}</h2>
              <button onClick={onClose} aria-label="বন্ধ করুন" className="rounded p-1 text-slate-400 hover:bg-slate-100" data-id="element-716" data-mp="3p0g7ppkebirk"><X className="h-4 w-4" data-id="element-717" data-mp="7sm85kbyaf0j" /></button>
            </header>
            <div className="overflow-y-auto p-5" data-id="element-718" data-mp="2thxep9do983">{children}</div>
            {footer && <footer className="flex justify-end gap-2 border-t border-border bg-slate-50 px-5 py-3" data-id="element-719" data-mp="29khj1xqdufhp">{footer}</footer>}
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}